import { render, staticRenderFns } from "./ClaimAddDialog.vue?vue&type=template&id=c8c68d5e&scoped=true&"
import script from "./ClaimAddDialog.vue?vue&type=script&lang=js&"
export * from "./ClaimAddDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c68d5e",
  null
  
)

export default component.exports